import type { StepConfig } from "@portal/components/multiform/types";
import type { AccountCreateFormData } from "../../schema";
import { FinancialsStep } from "./FinancialsStep";
import { FinancialsSummary } from "./FinancialsSummary";

export const financialsStepConfig: StepConfig<AccountCreateFormData> = {
	name: "financials",
	label: "Financials",
	fieldPaths: ["account.financials"],
	component: FinancialsStep,
	summaryComponent: FinancialsSummary,
};
